export const text = {
  Keys: "Keys",
  Desktop: "Desktop",
  Application: "Application",
  Employees: "Employees",
  "My Team": "My Team",
  "My Opinion": "My Opinion",
  "My Development": "My Development",
  Onboarding: "Onboarding",
  Academy: "Academy",
  Box: "Box",
  News: "News",
  Agenda: "Agenda",
  "Admin Overview": "Admin Overview",
  Modules: "Modules",
  Settings: "Settings",
  HR: "HR",
  "Leave Settings": "Leave Settings",
};
